module.exports = __webpack_public_path__ + "static/media/brodremoen.06ba49de.jpg";